@if (hasAnyKeys()) {
  <div class="__toolbar">
    @if (showSearch()) {
      <div class="__search">
        <mat-icon class="__search-icon">search</mat-icon>
        <input
          class="__search-input"
          type="search"
          placeholder="Filter overrides…"
          [ngModel]="search()"
          (ngModelChange)="search.set($event)" />
      </div>
    }
    <button
      type="button"
      class="__reset"
      [disabled]="setCount() === 0"
      (click)="resetAll()">
      Reset all
    </button>
  </div>

  @if (filteredEntries().length === 0) {
    <div class="__empty">No overrides match "{{ search() }}".</div>
  }

  <div class="__rows">
    @for (entry of filteredEntries(); track entry.name) {
      <div class="__row">

        <div class="__row-meta">
          <code class="__row-name">{{ entry.name }}</code>
          @if (entry.description) {
            <div class="__row-desc">{{ entry.description }}</div>
          }
        </div>

        <div class="__row-control">
          @switch (entry.dataType) {

            @case ('bool') {
              <div class="__bool-toggle">
                <button
                  type="button"
                  class="__bool-toggle_btn"
                  [class.is-active]="boolStateOf(entry.name) === 'unset'"
                  (click)="onBoolChange(entry.name, 'unset')">
                  Default
                </button>
                <button
                  type="button"
                  class="__bool-toggle_btn"
                  [class.is-active]="boolStateOf(entry.name) === 'off'"
                  (click)="onBoolChange(entry.name, 'off')">
                  Off
                </button>
                <button
                  type="button"
                  class="__bool-toggle_btn"
                  [class.is-active]="boolStateOf(entry.name) === 'on'"
                  (click)="onBoolChange(entry.name, 'on')">
                  On
                </button>
              </div>
            }

            @case ('byte') {
              <mat-form-field appearance="outline" color="accent" class="__field __field--num">
                <input
                  matInput
                  type="number"
                  step="any"
                  placeholder="default"
                  [ngModel]="displayOf(entry.name)"
                  (ngModelChange)="onTextChange(entry.name, entry.dataType, $event)" />
              </mat-form-field>
              <mat-form-field appearance="outline" color="accent" class="__field __field--unit">
                <mat-select
                  [value]="unitOf(entry.name, entry.dataType)"
                  (selectionChange)="onUnitChange(entry.name, 'byte', $event.value)">
                  @for (u of byteUnits; track u.value) {
                    <mat-option [value]="u.value">{{ u.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }

            @case ('nanosecond') {
              <mat-form-field appearance="outline" color="accent" class="__field __field--num">
                <input
                  matInput
                  type="number"
                  step="any"
                  placeholder="default"
                  [ngModel]="displayOf(entry.name)"
                  (ngModelChange)="onTextChange(entry.name, entry.dataType, $event)" />
              </mat-form-field>
              <mat-form-field appearance="outline" color="accent" class="__field __field--unit">
                <mat-select
                  [value]="unitOf(entry.name, entry.dataType)"
                  (selectionChange)="onUnitChange(entry.name, 'nanosecond', $event.value)">
                  @for (u of nsUnits; track u.value) {
                    <mat-option [value]="u.value">{{ u.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }

            @case ('int') {
              <mat-form-field appearance="outline" color="accent" class="__field __field--num">
                <input
                  matInput
                  type="number"
                  step="1"
                  placeholder="default"
                  [ngModel]="displayOf(entry.name)"
                  (ngModelChange)="onTextChange(entry.name, entry.dataType, $event)" />
              </mat-form-field>
            }

            @case ('float') {
              <mat-form-field appearance="outline" color="accent" class="__field __field--num">
                <input
                  matInput
                  type="number"
                  step="any"
                  placeholder="default"
                  [ngModel]="displayOf(entry.name)"
                  (ngModelChange)="onTextChange(entry.name, entry.dataType, $event)" />
              </mat-form-field>
            }

            @default {
              <mat-form-field appearance="outline" color="accent" class="__field __field--text">
                <input
                  matInput
                  type="text"
                  placeholder="default"
                  [ngModel]="displayOf(entry.name)"
                  (ngModelChange)="onTextChange(entry.name, entry.dataType, $event)" />
              </mat-form-field>
            }
          }
        </div>

      </div>
    }
  </div>
}
